@use '@/styles/tokens' as *;

.body {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  border-bottom: 1px solid var(--border-subtle);
}

/* The whole row is the affordance (Figma draws a caret but no separate control). */
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  width: 100%;
  padding: 10px var(--space-1); // Figma 429:283700 — no matching --space token
  border: none;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: var(--surface-subtle);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.text {
  display: flex;
  flex-direction: column;
  gap: 6px; // Figma dimensions/spacing/1.5 — no matching --space token
  min-width: 0;
}

.name {
  font-size: $font-size-lg;
  font-weight: $font-weight-medium;
  color: var(--text-primary);
  overflow-wrap: break-word;
}

.meta {
  font-size: $font-size-xs;
  color: var(--text-muted);
}

.trailing {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-shrink: 0;
}

.caret {
  color: var(--text-disabled);
}

// Figma 429:278729 — the block is centred in the drawer body, not offset from the top, so it fills
// the free space rather than carrying a fixed top padding.
.empty {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-4);
}

.emptyIcon {
  opacity: 0.3;
}

.emptyText {
  margin: 0;
  font-size: $font-size-md;
  font-weight: $font-weight-medium;
  color: var(--text-primary);
}

// No Figma frame covers the failure state, so it reuses the empty state's centred slot and tokens.
// Unlike the replacement sibling this one carries a retry — AC 112445 asks for one explicitly.
.notice {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  text-align: center;
}

.noticeText {
  margin: 0;
  font-size: $font-size-md;
  color: var(--text-primary);
}

// Figma 429:283742 — the pill sits bottom-right of the panel, below whatever the body holds, so it
// is pushed down by `margin-top: auto` rather than positioned. Copied from the shipped sibling
// listing so the twin drawers stay in step (ADR-0023). The Cancel slot Figma leaves `hidden` in
// this frame is not built.
.action {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: var(--space-4);
}
